<template>
<table class="creature-statistics">
  <tr>
    <statistics-cell name="Armor Class" :value="armorClass" />
    <statistics-cell name="Attack Bonus" :value="attackBonus | sign" />
  </tr>
  <tr>
    <statistics-cell name="Hit Points" :value="`${hitPoints} (3x ${Math.floor(hitPoints / 3)})`" v-if="type == 'solo'" />
    <statistics-cell name="Hit Points" :value="`${hitPoints} (${Math.floor(hitPoints / 2)})`" v-else />
    <statistics-cell name="Damage" :value="damage" />
  </tr>
  <tr>
    <statistics-cell name="Saving Throws" :value="savingThrows | arraySign" />
    <statistics-cell name="Spell DC" :value="spellDC" />
  </tr>
  <tr>
    <statistics-cell name="Initiative" :value="initiative | sign" />
    <statistics-cell name="Perception" :value="perception | sign" />
  </tr>
  <tr>
    <statistics-cell name="Speed" :value="speed + ' ft'" />
    <statistics-cell name="Stealth" :value="stealth | sign" />
  </tr>
  <tr>
    <statistics-cell colspan="2" name="Ability Modifiers" :value="abilityModifiers | arraySign" />
  </tr>
</table>
</template>

<script>
import StatisticsCell from './statistics-cell.vue';

export default {
  props: [
    'armorClass', 'attackBonus',
    'hitPoints', 'damage',
    'savingThrows', 'spellDC',
    'initiative', 'perception',
    'speed', 'stealth',
    'abilityModifiers', 'type'],

  filters: {
    sign(value) {
      if(isNaN(value)) return '+0';
      value = parseInt(value, 10);
      return value < 0 ? value : `+${value}`;
    },
    arraySign(value) {
      if(!Array.isArray(value) || !value.every(e => !isNaN(e))) return '';
      return value.map(e => {
        e = parseInt(e, 10);
        return e < 0 ? e : `+${e}`;
      }).join(', ');
    }
  },
  components: {
    StatisticsCell
  }
}
</script>

<style lang="scss">
.creature-block .creature-statistics {
  width: 100%;

  tr:nth-child(odd) {
    background-color: #fce7c4;
  }
  td {
    width: 50%;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/creature-statistics.vue